<template>
<div>
  <div class="selector-container">
    <transition
      name="slide-down"
      v-on:after-leave="handleContentChanged"
      v-on:after-enter="handleContentChanged"
    >
      <div class="fabric-container" v-if="!(isCOM || isDecideLater)">
        <div class="block-dropdown block-category mustard-select">
          <select
            id="sel_fabric_cat"
            name="fabric_cat"
            v-model="activeCategory"
            @change="activeIndex = 0"
          >
            <option
              v-for="(category, index) in categories"
              :key="'cat_' + index"
              :value="category"
            >
              {{ category }}
            </option>
          </select>
          <svg width="13" height="7" viewBox="0 0 13 7" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M13 -1.19209e-07L6.5 7L0 -1.19209e-07L13 -1.19209e-07Z" fill="currentColor"/>
          </svg>

        </div>
        <div class="comp-selected-fabric">
          <div>
            You Have Selected: 
            <span class="fabric-name" v-if="isDecideLater">Decide Later</span>
            <span class="fabric-name" v-else-if="isCOM">COM</span>
            <span class="fabric-name" v-else>{{ activeOption.title }}{{ activeOption.backorder_date ? ` * Back In Stock ${new Date(activeOption.backorder_date).toLocaleDateString('en-US',{timeZone: "UTC", year: '2-digit', month: '2-digit', day:'2-digit'})}` : '' }}</span>
          </div>
          <a
            href="#frm_fabric_info"
            class="fabric-popup-trigger info-link"
            @click.prevent="handleFabricDetailModal"
            ><span class="icon-info"></span
          ></a>
        </div>
        <ImageMagnifier v-if="!isDecideLater" :image="activeOption.image_url" />
        <div class="shipping_length">
          {{ shippingString }}
        </div>
        <div class="product-fabric-selector">
          <ImageOptionCardFabric
            v-for="(option, index) in categoryOptions"
            :key="option.title"
            :option="option"
            type="fabric"
            :is-active="index === activeIndex"
            @click="updateActiveOption(index)"
          />
        </div>
      </div>
    </transition>
    <div class="block-pick-later">
      <label v-if="!isCOM" for="chk_pick_color_later" class="with-icon">
        <div class="icon-text">
          <span>Can't Decide? Pick Your Material Later</span>
          <a
            class="decide-later-info info-link"
            href="//cdn.shopify.com/s/files/1/0250/3304/8148/t/121/assets/decide-later-popup-image.jpg?v=15591482406549092723"
            @click.prevent="handleDecideLaterModal"
          >
            <span class="icon-info choose-later"></span>
          </a>
        </div>
        <div class="custom-checkbox" :class="{active: isDecideLater}">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
            <path stroke-linecap="" stroke-linejoin="" d="M4.5 12.75l6 6 9-13.5" />
          </svg>
        </div>
        <input
          id="chk_pick_color_later"
          name="chk_pick_color_later"
          type="checkbox"
          v-model="isDecideLater"
          style="display:none!important;"
        />
      </label>
      <div v-if="productType !== 'Pillows'">
        <label v-if="!isDecideLater" for="chk_com" class="with-icon">
          <div class="icon-text">
            <span>Trade Only - COM</span>
            <a
              class="decide-later-info info-link"
              @click.prevent="handleCOMModal"
            >
              <span class="icon-info choose-later"></span>
            </a>
          </div>
          <div class="custom-checkbox" :class="{active: isCOM}">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
              <path stroke-linecap="" stroke-linejoin="" d="M4.5 12.75l6 6 9-13.5" />
            </svg>
          </div>
          <input
            id="chk_com"
            name="chk_com"
            type="checkbox"
            v-model="isCOM"
            style="display:none!important;"
          />
        </label>
      </div>
    </div>
    <div v-if="isDecideLater" class="shipping_length decide_later">
      {{ shippingString }}
    </div>
    <div v-if="isCOM" class="shipping_length decide_later">
      Timeline Available After Material is Received
    </div>
    <FabricModal
      :is-open="showFabricDetailModal"
      :active-fabric="activeOption"
      @modal-close="handleFabricDetailModal"
    />
    <DecideLaterModal
      :is-open="showDecideLaterModal"
      @modal-close="handleDecideLaterModal"
    />
    <COMModal
      :is-open="showCOMModal"
      @modal-close="handleCOMModal"
    />
  </div>
  <div class="cta-container">
    <a href="/pages/order-swatches" target="_blank" class="fab-cta" >
      Order Free Swatches
    </a>
    <div class="cta-kicker">
      Swatches Ship Within 24 Hours
    </div>
  </div>
</div>
</template>
<script>
import FabricModal from "./FabricModal.vue";
import DecideLaterModal from "./DecideLaterModal.vue";
import COMModal from "./COMModal.vue";
import ImageMagnifier from "./ImageMagnifier.vue";
import ImageOptionCardFabric from "./ImageOptionCardFabric.vue";
export default {
  name: "ProductFabricSelector",
  props: {
    options: Array,
    selectedProduct: Object,
    productType: String,
    shipping: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    FabricModal,
    DecideLaterModal,
    COMModal,
    ImageMagnifier,
    ImageOptionCardFabric
},
  data() {
    return {
      decideLaterKey: "Decide Later",
      COMKey: "Customer Own Materials",
      activeIndex: 0,
      activeCategory: "",
      fabricOptions: this.options || [],
      categories: [],
      activeOption: this.options[0] || {},
      categoryOptions: [],
      isDecideLater: false,
      isCOM: false,
      showDecideLaterModal: false,
      showCOMModal: false,
      showFabricDetailModal: false,
      LEAD_TIME_KEY: "factory_days",
      IGNORE_SHIPPING_FABRICS: ["Decide Later", "Customer Own Materials"],
    };
  },
  watch: {
    activeCategory: function (newCategory) {
      this.$emit("fabric-changed", newCategory);
      this.updateCategoryOptions();
      this.maybeSetDefaultColor();
    },
    isDecideLater: function (isDecideLater) {
      if (isDecideLater) {
        if (this.isCOM) { this.isCOM = !this.isCOM; }
        this.$emit("fabric-changed", this.decideLaterKey);
        this.$emit("color-changed", "");
        this.$emit("lead-time-changed", 0);
        this.$emit("scroll-to-container-top");
      } else if (!this.activeCategory) {
        if (this.isCOM) { return; }
        this.activeCategory = this.categories[0];
        this.updateActiveOption(0);
      } else {
        if (this.isCOM) { return; }
        this.$emit("fabric-changed", this.activeCategory);
        this.updateActiveOption(this.activeIndex);
      }
    },
    isCOM: function (isCOM) {
      if (isCOM) {
        if (this.isDecideLater) { this.isDecideLater = !this.isDecideLater; }
        this.$emit("fabric-changed", this.COMKey);
        this.$emit("color-changed", "");
        this.$emit("lead-time-changed", 0);
        this.$emit("scroll-to-container-top");
      } else if (!this.activeCategory) {
        if (this.isDecideLater) { return; }
        this.activeCategory = this.categories[0];
        this.updateActiveOption(0);
      } else {
        if (this.isDecideLater) { return; }
        this.$emit("fabric-changed", this.activeCategory);
        this.updateActiveOption(this.activeIndex);
      }
    },
  },
  computed: {
    shippingString() {
      if (this.IGNORE_SHIPPING_FABRICS.includes(this.selectedProduct.fabric)) {
        switch(this.selectedProduct.fabric) {
          case 'Customer Own Materials':
            return "Timeline Available After Material is Received";
          default:
            return "Timeline Available After Material is Selected";
        }
      }
      let activeBaseTime = parseInt(this.shipping.all);
      if (this.shipping[this.selectedProduct.sku]) {
        activeBaseTime = parseInt(this.shipping[this.selectedProduct.sku]);
      }
      let timeString = `${activeBaseTime} Days`;
      if (activeBaseTime > 14) {
        timeString = `${Math.ceil(activeBaseTime / 7)} Weeks`;
      }
      return `Your Order Is Custom Made In Est. ${timeString}`;
    },
  },
  mounted() {
    this.hasMounted = true;

    this.fabricOptions.forEach((option) => {
      const optionCategories = option["fabric_options"];
      optionCategories.forEach((category) => {
        if (!this.categories.includes(category)) {
          this.categories.push(category);
        }
        if (this.selectedProduct.fabric === category) {
          this.activeCategory = category;
        }
      });
    });
    
    // NOTE this is a work around to put leather at the end
    const leather = this.categories.find((option) => option == 'Premium Leather')
    if (leather) {
      this.categories.splice(this.categories.indexOf(leather),1)
      this.categories.push(leather)
    }

    if (this.selectedProduct.fabric === this.decideLaterKey) {
      this.isDecideLater = true;
    }
    if (this.selectedProduct.fabric === this.COMKey) {
      this.isCOM = true;
    }
    this.updateCategoryOptions();
    this.maybeSetDefaultColor();
  },
  methods: {
    handleContentChanged() {
      this.$emit("selector-content-updated");
    },
    maybeSetDefaultColor() {
      let index = 0;
      const searchParams = new URLSearchParams(window.location.search);
      if (searchParams.has("color")) {
        const matchingIndex = this.categoryOptions.findIndex(
          (option) => option.title == searchParams.get("color")
        );
        if (matchingIndex >= 0) {
          index = matchingIndex;
        }
      }
      this.updateActiveOption(index);
      
    },
    updateActiveOption(index) {
      try {
        this.activeIndex = index;
        this.activeOption = this.categoryOptions[this.activeIndex];
        this.$emit("color-changed", this.activeOption);
        this.$emit(
          "lead-time-changed",
          this.categoryOptions[this.activeIndex][this.LEAD_TIME_KEY]
        );
      } catch {
        // NOTE we're functionallity ignoring this error to ensure that Avaatar works
      }
      
    },
    handleFabricDetailModal() {
      this.changeModalVisibility(this.showFabricDetailModal);
      this.showFabricDetailModal = !this.showFabricDetailModal;
    },
    handleDecideLaterModal() {
      this.changeModalVisibility(this.showDecideLaterModal);
      this.showDecideLaterModal = !this.showDecideLaterModal;
    },
    handleCOMModal() {
      this.changeModalVisibility(this.showCOMModal);
      this.showCOMModal = !this.showCOMModal;
    },
    changeModalVisibility(modalOpen) {
      if (modalOpen) {
        document.querySelector("body").style.overflow = null;
        document.querySelector("body").style.marginRight = null;
      } else {
        document.querySelector("body").style.overflow = "hidden";
        document.querySelector("body").style.marginRight = "15px";
      }
    },
    updateCategoryOptions() {
      this.categoryOptions = this.fabricOptions
        .filter(
          (option) =>
            option["fabric_options"].includes(this.activeCategory) &&
            !option["is_hidden"]
        )
        .sort((firstEl, secondEl) => (firstEl.title < secondEl.title ? -1 : 1));
    },
  },
};
</script>
<style scoped>
.custom-checkbox {
  background: #F0F0F0;
  border: 0.8px solid #393534;
  height: 17px;
  width: 17px;
  display: flex;
  align-items:center;
  justify-content: center;
  user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  -webkit-user-select: none;
}
.custom-checkbox svg {
  height: 100%;
  width: 100%;
  transition: 0.3s ease-in-out;
  opacity: 0;
}
.custom-checkbox.active svg {
  opacity: 1;
}
.shipping_length {
  font-weight: 500;
  font-size: 14px;
  line-height: 140%;
  text-align: left;
  padding: 5px 0 15px;
}
.shipping_length.decide_later {
  margin-top: 10px;
  align-self: flex-start;
  padding-bottom: 0;
}
input,
label {
  cursor: pointer;
}
.selector-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}
/* .fabric-container,
.block-pick-later {
  max-width: 311px;
} */
.block-dropdown {
  position: relative;
}
.block-dropdown:hover svg {
  color: #fff;
}
select + svg {
  position: absolute;
  top: calc(50% - 3px);
  right: 16px;
  color: #7c7473;
}
.fabric-container {
  transition: max-height 0.4s;
}
.product-fabric-selector {
  padding: 8px 7px;
  overflow: auto;
  max-height: 360px;
  gap: 7px;
  border-radius: 5px;
  border: 1px solid #DDD;
  background: #F4F4F4;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
}
select {
  border: 1px solid #000000;
  border-radius: 4px;
  padding: 23px 10px;
  margin-bottom: 0;
  color: #3a3830;
  font-size: 18px;
  font-weight: 500;
  line-height: 17px;
  text-align-last: center;
  width: 100%;
  max-width: 100%;
  display: block;
  margin-bottom: 0.75em;
  background-color: transparent;
  outline: 0;
  appearance: none;
  /* background-position: right center;
  background-image: url("//cdn.shopify.com/s/files/1/0250/3304/8148/t/121/assets/ico-select.svg?v=14119474279334961291");
  background-repeat: no-repeat; */
  background-position: right 10px center;
  background-color: transparent;
  text-indent: 0.01px;
  cursor: pointer;
  box-shadow: none;
  transition: 0.2s ease-in-out;
}
select:hover {
  background-color: #3a3830;
  color: #fff;
}
select:hover + svg {
  color: #fff;
}
.with-icon {
  display: flex;
  align-items: center;
  text-align: start;
  font-size: 16px;
  line-height: 140%;
  gap: 24px;
  padding-top: 10px;
}
.icon-text {
  display: flex;
  align-items: center;
}
.comp-selected-fabric {
  display: flex;
  gap: 12px;
  /* margin-bottom: 0.5em; */
  font-weight: 400;
  font-size: 16px;
  line-height: 140%;
  padding: 5px 0 17px;
}
.info-link {
  cursor: pointer;
  text-decoration: none;
  display: flex;
  align-items: center;
  color: #4B87EE;
}
.icon-info {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  width: 100%;
  -webkit-justify-content: center;
  -ms-justify-content: center;
  justify-content: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  -moz-align-items: center;
  -ms-align-items: center;
  -o-align-items: center;
  align-items: center;
  align-items: center;
  border: 2px solid #4B87EE;
  border-radius: 50%;
  width: 15px;
  height: 15px;
  color: #4B87EE;
  font-size: 12px;
  font-weight: 700;
  text-transform: none;
  line-height: 1em;
}
.decide-later-info.info-link {
  position: unset;
}
.icon-info::after {
  content: "i";
  margin-top: 1px;
}
.icon-info.choose-later {
  display: inline-flex;
  right: unset;
  top: unset;
  transform: unset;
  margin-left: 7px;
  position: relative;
}
.block-pick-later {
  align-self: flex-start;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 8px;
  align-items: flex-start;
  flex-direction: column;
}
.slide-down-enter-active {
  transition: max-height 0.1s ease-out;
}
.slide-down-leave-active {
  transition: max-height 0.4s ease-out;
}

.slide-down-enter-to,
.slide-down-leave {
  overflow: hidden;
  max-height: 1000px;
}

.slide-down-enter,
.slide-down-leave-to {
  overflow: hidden;
  max-height: 0;
}
.cta-container {
  margin-top:18px;
}
.fab-cta {
  border: 1px solid #000000;
  border-radius: 4px;
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 400;
  font-size: 18px;
  line-height: 140%;
  padding: 23px;
  transition: 0.2s ease-in-out;
}
.fab-cta, .fab-cta:visited {
  color: #000000;
}
.fab-cta:hover {
  background-color: #3a3830;
  color: #F0F0F0;
}
.cta-kicker {
  font-weight: 400;
  font-size: 14px;
  line-height: 140%;
  text-align: center;
  padding-top: 14px;
}
</style>
